import Cookies from 'js-cookie';

const COOKIE_NAME = 'fs_optly_user_id';
const EXPIRES_DAYS = 365;

function getRootDomain(): string | undefined {
	if (typeof window === 'undefined') return undefined;
	const hostname = window.location.hostname;
	const parts = hostname.split('.');
	// localhost, IPs, or single-label hosts: don't scope the domain
	const isLocalOrIp =
		parts.length <= 1 || hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname);
	if (isLocalOrIp) return undefined;
	// e.g. www.fourseasons.com → .fourseasons.com
	return '.' + parts.slice(-2).join('.');
}

export function getOrCreateUserId(): string | null {
	if (typeof window === 'undefined') return null;
	const existing = Cookies.get(COOKIE_NAME);
	if (existing) return existing;
	const id = crypto.randomUUID();
	Cookies.set(COOKIE_NAME, id, { expires: EXPIRES_DAYS, domain: getRootDomain(), sameSite: 'lax' });
	return id;
}

export function deleteUserId(): void {
	Cookies.remove(COOKIE_NAME, { domain: getRootDomain(), path: '/' });
}
